export default {
  SET_SUBSCRIPTION_PLAN (state, plan) {
    state.active_plan = plan
  },
  SET_CURRENCY (state, currency) {
    state.currency = currency
  },
  SET_ROLE (state, role) {
    state.role = role
  },
  SET_EMAIL (state, email) {
    state.email = email
  },
  SET_IP_DATA (state, ipData) {
    state.ip_data = ipData
  },
  SET_PERMISSIONS (state, permissions) {
    if (permissions !== undefined) {
      state.permissions = permissions
    }
  },
  SET_USER (state, user) {
    if (user.id !== undefined) {
      state.id = user.id
    }
    if (user.email !== undefined) {
      state.email = user.email
    }
    if (user.fullname !== undefined) {
      state.fullname = user.fullname
    }
    if (user.work_in !== undefined) {
      state.work_in = user.work_in
    }
    if (user.role !== undefined) {
      state.role = user.role
    }
    if (user.status !== undefined) {
      state.status = user.status
    }
    if (user.signup !== undefined) {
      state.signup = user.signup
    }
    if (user.activated !== undefined) {
      state.activated = user.activated
    }
    if (user.last_login !== undefined) {
      state.last_login = user.last_login
    }
    if (user.credits !== undefined) {
      state.credits = user.credits
    }
    if (user.keywords_count !== undefined) {
      state.keywords_count = user.keywords_count
    }
    if (user.projects_count !== undefined) {
      state.projects_count = user.projects_count
    }
    if (user.reports_count !== undefined) {
      state.reports_count = user.reports_count
    }
    if (user.links_count !== undefined) {
      state.links_count = user.links_count
    }
    // if (user.permissions !== undefined) {
    //   state.permissions = user.permissions
    // }
    if (user.overridden_permissions !== undefined) {
      state.overridden_permissions = user.overridden_permissions
    }
    if (user.projects !== undefined) {
      state.projects = user.projects
    }
    if (user.first_day !== undefined) {
      state.first_day_of_week = user.first_day
    }
    if (user.package_id !== undefined) {
      state.package_id = user.package_id
    }
    if (user.package_expired_at !== undefined) {
      state.package_expired_at = user.package_expired_at
    }
    if (user.keywords_limit !== undefined) {
      state.keywords_limit = user.keywords_limit
    }
    if (user.projects_limit !== undefined) {
      state.projects_limit = user.projects_limit
    }
    if (user.links_limit !== undefined) {
      state.links_limit = user.links_limit
    }
    if (user.reports_limit !== undefined) {
      state.reports_limit = user.reports_limit
    }
    if (user.history_starts_at !== undefined) {
      state.history_starts_at = user.history_starts_at
    }
    if (user.first_day !== undefined) {
      state.first_day_of_week = user.first_day
    }
    if (user.made_reports !== undefined) {
      state.made_reports = user.made_reports
    }
    if (user.currency !== undefined) {
      state.currency = user.currency
    }
    // if (user.is_ten_club_member !== undefined) {
    //   state.is_ten_club_member = user.is_ten_club_member
    // }
    if (user.ten_club_reports !== undefined) {
      state.ten_club_reports = user.ten_club_reports || []
    }
    if (user.subscription_renew !== undefined) {
      state.subscription_renew = user.subscription_renew
    }
    if (user.is_trial_available !== undefined) {
      state.is_trial_available = user.is_trial_available
    }
    if (user.is_trial !== undefined) {
      state.is_trial = user.is_trial
    }
    if (user.package_type !== undefined) {
      state.package_type = user.package_type
    }
  },
  CLEAR_USER (state) {
    state.id = null
    state.email = null
    state.fullname = null
    state.phone_number = null
    state.work_in = null
    state.role = null
    state.status = null
    state.signup = null
    state.activated = null
    state.last_login = null
    state.credits = null
    state.keywords_count = 0
    state.projects_count = 0
    state.reports_count = 0
    state.links_count = 0
    state.permissions = null
    state.overridden_permissions = null
    state.projects = null
    state.first_day_of_week = 0
    state.package_id = 0
    state.package_expired_at = ''
    state.keywords_limit = 0
    state.projects_limit = 0
    state.links_limit = 0
    state.reports_limit = 0
    state.history_starts_at = ''
    state.made_reports = 0
    state.subscription_renew = null
    state.ten_club_reports = []
    state.currency = 1
    state.is_trial_available = null
    state.is_trial = null
    state.package_type = null
  }
}



// WEBPACK FOOTER //
// ./src/store/user/mutations.js